var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "664px",
    height: "664px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.166666666666664,27.166666666666664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.5,
    y: -18.5,
    width: 37,
    height: 37,
    fill: "#5e6fa3"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "0.9174311926605504s",
    keyTimes: "0;1",
    values: "1.2200000000000002;1",
    begin: "-0.2752293577981651s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.83333333333333,27.166666666666664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.5,
    y: -18.5,
    width: 37,
    height: 37,
    fill: "#d9dbee"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "0.9174311926605504s",
    keyTimes: "0;1",
    values: "1.2200000000000002;1",
    begin: "-0.1834862385321101s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.166666666666664,72.83333333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.5,
    y: -18.5,
    width: 37,
    height: 37,
    fill: "#3b4368"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "0.9174311926605504s",
    keyTimes: "0;1",
    values: "1.2200000000000002;1",
    begin: "0s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.83333333333333,72.83333333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.5,
    y: -18.5,
    width: 37,
    height: 37,
    fill: "#689cc5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "0.9174311926605504s",
    keyTimes: "0;1",
    values: "1.2200000000000002;1",
    begin: "-0.09174311926605505s"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.77127ae105471d6eb4142cfd4a42c0f7.svg";
export { ForwardRef as ReactComponent };